import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const constantRouterMap = [
  // {
  //   path: '/audio',
  //   name: 'index',
  //   component: (resolve) => require(['@/views/audio'], resolve),
  //   meta: { title: '录音' },
  // },
  {
    path: '/audio2',
    name: 'index',
    component: (resolve) => require(['@/views/audio2'], resolve),
    meta: { title: '录音' },
  },
  // {
  //   path: '/audio3',
  //   name: 'index',
  //   component: (resolve) => require(['@/views/audio3'], resolve),
  //   meta: { title: '录音' },
  // },
  {
    path: '/',
    name: 'index',
    component: (resolve) => require(['@/views/pc/bookShelf/index'], resolve),
    meta: { title: '我的书架' },
  },
  {
    path: '/login',
    name: 'login',
    component: (resolve) => require(['@/views/pc/login'], resolve),
    meta: { title: '登录' },
  },
  {
    path: '/bookShelf',
    name: 'bookShelf',
    component: (resolve) => require(['@/views/pc/bookShelf/index'], resolve),
    meta: { title: '我的书架' },
  },
  {
    path: '/bookReader',
    name: 'bookReader',
    component: (resolve) => require(['@/views/pc/bookReader/index'], resolve),
    meta: { title: '阅读页' },
  },

  // 手机端网页
  {
    path: '/m',
    name: 'm-index',
    component: (resolve) => require(['@/views/m/bookShelf/index'], resolve),
    meta: { title: '我的书架' },
  },

  {
    path: '/m/bookShelf',
    name: 'm-bookShelf',
    component: (resolve) => require(['@/views/m/bookShelf/index'], resolve),
    meta: { title: '我的书架' },
  },
  {
    path: '/m/bookReader',
    name: 'm-bookReader',
    component: (resolve) => require(['@/views/m/bookReader/index'], resolve),
    meta: { title: '阅读页' },
  },
]

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: constantRouterMap
})